import { Subjects } from "../permission/constants";
import {
  Brand,
  Competition,
  Player,
  Season,
  ShirtType,
  Team,
  Variant,
} from "../services/shirts/types";
import { ShirtModelInterface } from "../services/shirts/types";

export class ShirtModel {
  id: number;
  type: ShirtType;
  number: number | undefined;
  text: string | undefined;
  brand: Brand;
  competition: Competition;
  player: Player;
  season: Season;
  team: Team;
  variant: Variant;

  static get modelName(): string {
    return Subjects.SHIRT_MODEL;
  }

  constructor(dataModel: ShirtModelInterface) {
    this.id = dataModel.id;
    this.type = dataModel.type;
    this.number = dataModel.number;
    this.text = dataModel.text;
    this.brand = dataModel.brand;
    this.competition = dataModel.competition;
    this.player = dataModel.player;
    this.season = dataModel.season;
    this.team = dataModel.team;
    this.variant = dataModel.variant;
  }
}
